
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/enterprise",
      function () {
        return require("private-next-pages/solutions/enterprise/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/enterprise"])
      });
    }
  